import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'password',
  renderInput: ({ field, value, onChange }) => {
    const [show, setShow] = useState(false);
    return (
      <div className="relative">
        <input
          type={show ? 'text' : 'password'}
          value={(value as string) ?? ''}
          onChange={(e) => onChange(e.target.value || null)}
          placeholder={field.isRequired ? undefined : '••••••••'}
          className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 pr-9 text-sm text-text-primary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-primary"
          tabIndex={-1}
        >
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    );
  },
  renderCell: () => <span className="text-text-muted">••••••••</span>,
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    return null;
  },
  defaultValue: null,
});
